import { UserInfo } from '@vcd-ecm-ui/Common';
import {
  USER_INFO_REQUEST_SUCCEEDED,
  UserHookActionTypes,
  USER_INFO_REQUESTED,
} from './user-hook-action-types';

interface UserState {
  userInfoRequested: boolean;
  userInfo: UserInfo;
}

const initialState: UserState = {
  userInfoRequested: false, // Prevent duplicate Requests on Startup
  userInfo: null,
};

const userHookReducer = (state = initialState, action: UserHookActionTypes): UserState => {
  switch (action.type) {
    case USER_INFO_REQUESTED:
      return { ...state, userInfoRequested: true };
    case USER_INFO_REQUEST_SUCCEEDED:
      return { ...state, userInfo: action.payload.userInfo };
    default:
      return state;
  }
};

export default userHookReducer;
